export default __webpack_public_path__ + "static/media/analytics.f5aa72d9.svg";